import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

export const useInvoicePrinter = (id) => {
    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => document.getElementById(id),
        onBeforeGetContent: () => {
            // You can apply additional style or logic adjustments here

            const element = document.getElementById(id);
            if (element) {
                // Apply specific styles if necessary

                element.style.width = '100%';
                element.style.height = 'auto';
                element.style.overflow = 'visible';
            }
        },
        onAfterPrint: () => {
            // Restores styles if necessary

            const element = document.getElementById(id);
            if (element) {
                element.style.width = '';
                element.style.height = '';
                element.style.overflow = '';
            }
        },
    });

    return {
        componentRef,
        handlePrint,
    };
};
